import { Children } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Card from '../Card';

import styles from './_index.module.scss';

const TopicLibraryCard = ({
  actions = [],
  children = null,
  footer = null,
  icon = null,
  isActive = false,
  tabIndex = 0,
  title = null,
  ...rest
}) => {
  return (
    <Card
      className={classNames(styles['topic-library-card'], {
        [styles['is-active']]: isActive,
      })}
      padding="small"
      tabIndex={tabIndex}
      {...rest}
    >
      {icon && <div className={styles['topic-library-card-icon']}>{icon}</div>}

      <div className={styles['topic-library-card-right']}>
        <div className={styles['topic-library-card-content']}>
          <div className={styles['topic-library-card-body']}>
            {title && <div className={styles['topic-library-card-title']}>{title}</div>}
            {children}
          </div>

          {actions.length > 0 && (
            <div className={styles['topic-library-card-actions']}>{Children.toArray(actions)}</div>
          )}
        </div>

        {footer && <div className={styles['topic-library-card-divider']} />}

        {footer && <div className={styles['topic-library-card-footer']}>{footer}</div>}
      </div>
    </Card>
  );
};

TopicLibraryCard.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.node),
  children: PropTypes.node,
  footer: PropTypes.node,
  icon: PropTypes.node,
  isActive: PropTypes.bool,
  tabIndex: PropTypes.number,
  title: PropTypes.node,
};

export default TopicLibraryCard;
